export default __webpack_public_path__ + "static/media/image6.8e68d0f6.png";